import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import AboutStats from './components/AboutStats';
import AboutValues from './components/AboutValues';
import AboutTeam from './components/AboutTeam';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <AboutMission />
        <AboutStats />
        <AboutValues />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}
